import React, { Component } from "react";
import "../Account.css"
import SignupHeader from "./signup.header";
import SignupFooter from "./signup.footer";
import { Link } from "react-router-dom";
import axios from "axios";
// import { FaGooglePlusG } from "react-icons/fa";
// import { GoogleLogin } from '@react-oauth/google';
// import { jwtDecode } from "jwt-decode";
// import { useGoogleLogin } from '@react-oauth/google';
import GoogleSignup from "./google.signup";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa6";



class Signup extends Component {
  state = {
    firstName: '',
    middleName: '',
    lastName: '',
    phone: '',
    address: '',
    affiliation: '',
    advertise: '',
    otherOption: '',
    email: '',
    password: '',
    confirmPassword: '',
    error: null,
    loading: false, // Added loading state
    showPassword: false,
    showConfirmPassword: false,
  };


  componentDidMount() {
    const accessToken = localStorage.getItem('accessToken');
    const userString = localStorage.getItem('user');

    if (accessToken && userString) {
      try {
        const user = JSON.parse(userString);

        // Check if the user object has a 'role' property or similar to determine if they are a tutor
        if (user.role === 'tutor') {
          window.location.href = '/tutor_dashboard'; // Or whatever your tutor dashboard link is
        } else {
          window.location.href = '/dashboard'; // Or whatever your regular user dashboard link is
        }
      } catch (e) {
        console.error("Error parsing user data from localStorage:", e);
        // Handle the error, e.g., clear corrupted data or redirect to login
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        // window.location.href = '/login'; // Redirect to login if data is corrupted
      }
    } else {
      // If accessToken or user data doesn't exist, redirect to login or a default page
      //window.location.href = '/login'; // Or your default landing page
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    // Handle advertise and otherOption logic
    if (name === "advertise") {
      this.setState({ advertise: value });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ error: 'Passwords do not match' });
      return;
    }
    let sourceToSubmit = this.state.advertise; // Default source

    if (this.state.advertise === "Others") {
      sourceToSubmit = this.state.otherOption; // Use otherOption if "Others" is selected
    }
    this.setState({ loading: true, error: null }); // Set loading to true and clear previous errors
    try {
      const response = await axios.post('https://api.geoinfoacademy.com/api/register/', {
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        middle_name: this.state.middleName,
        email: this.state.email,
        address: this.state.address,
        phone_number: this.state.phone,
        affiliation: this.state.affiliation,
        source: sourceToSubmit,
        password: this.state.password,
        password2: this.state.confirmPassword,
      });

      // Handle successful signup (e.g., display a success message)
      console.log('Signup successful:', response.data);
      // Optionally, redirect the user to the login page
      console.log('Redirecting to login')
      window.location.href = '/login';
    }
    catch (error) {
      console.log("Full error object:", error);
      let errorMessage = "Signup failed. Please check your inputs.";

      if (error.response && error.response.data) {
        const errorData = error.response.data;
        console.log("Parsed error data:", errorData);

        // 1. If errorData is a direct string
        if (typeof errorData === 'string') {
          errorMessage = errorData;
        }
        // 2. If errorData has a Django 'detail' string
        else if (typeof errorData.detail === 'string') {
          errorMessage = errorData.detail;
        }
        // 3. If errorData is an array (e.g., ["This field must be unique."])
        else if (Array.isArray(errorData)) {
          errorMessage = errorData.join(' ');
        }
        // 4. If errorData is an object (standard DRF field errors dictionary)
        else if (typeof errorData === 'object' && errorData !== null) {
          const errorList = [];

          for (const [field, messages] of Object.entries(errorData)) {
            const fieldMessage = Array.isArray(messages) ? messages.join(' ') : messages;

            // If the key is a number or 'non_field_errors', just show the message directly
            if (!isNaN(field) || field === 'non_field_errors') {
              errorList.push(fieldMessage);
            } else {
              errorList.push(`${field}: ${fieldMessage}`);
            }
          }

          if (errorList.length > 0) {
            errorMessage = errorList.join(' | ');
          }
        }
      } else {
        errorMessage = "Network error or server unavailable.";
      }

      this.setState({ error: errorMessage });

      setTimeout(() => {
        this.setState({ error: "" });
      }, 7000);
    } finally {
      this.setState({ loading: false });
    }
  }
  handleOtherChange = (event) => {
    this.setState({ otherOption: event.target.value });
    // if (this.state.advertise === "Others") {
    //   this.setState({ advertise: event.target.value });
    // }
  };




  toggleVisibility = (field) => {
    this.setState((prev) => ({ [field]: !prev[field] }));
  };


  //  login = useGoogleLogin({
  //     onSuccess: tokenResponse => console.log(tokenResponse),
  //   });


  render() {
    console.log(this.state)
    return (
      <div className=" account_body sign-up">
        <SignupHeader />
        <h1 className="account_header">Sign Up </h1>
        <p className="account_body"> Make the most of your professional life </p>
        <div className="account_form_cover">
          <form className="account_form" onSubmit={this.handleSubmit}>
            <label htmlFor="firstName">First Name</label><br />
            <input placeholder="Enter Your First Name " type="text" id="firstName" name="firstName" value={this.state.firstName} onChange={this.handleChange} required /><br /><br />
            <label htmlFor="middleName">Middle Name</label><br />
            <input placeholder="Enter Your Middle Name " type="text" id="middleName" name="middleName" value={this.state.middleName} onChange={this.handleChange} /><br /><br />
            <label htmlFor="lastName">Last Name</label><br />
            <input placeholder="Enter Your Last Name " type="text" id="lastName" name="lastName" value={this.state.lastName} onChange={this.handleChange} required /><br /><br />
            <label htmlFor="phone">Phone No</label><br />
            <input placeholder="Enter Your phone number" type="number" id="phone" name="phone" value={this.state.phone} onChange={this.handleChange} min="0" required /><br /><br />
            <label htmlFor="address">Address</label><br />
            <input placeholder="Enter Your Address" type="text" id="address" name="address" value={this.state.address} onChange={this.handleChange} required /><br /><br />
            <label htmlFor="affiliation">Select Your Affiliation</label><br />
            <select name="affiliation" id='affiliation' value={this.state.affiliation} onChange={this.handleChange} required>
              <option value="">Select Affiliation</option>
              <option value="Student">Student</option>
              <option value="Private Sector">Private Sector</option>
              <option value="Public Sector (Government)">Public Sector (Government)</option>
            </select><br /><br />
            <label htmlFor="advertise">How did you get this information</label><br />
            <select name="advertise" id='advertise' value={this.state.advertise} onChange={this.handleChange} required>
              <option value="">Select</option>
              <option value="Friends">Friends</option>
              <option value="Families">Families</option>
              <option value="WhatsApp">WhatsApp</option>
              <option value="T.V/Radio">T.V/Radio</option>
              <option value="School">School</option>
              <option value="Social Media">Social Media</option>
              <option value="Google">Google</option>
              <option value="Others">Others</option>
            </select><br /><br />
            {this.state.advertise === 'Others' && (
              <div><input
                type="text"
                placeholder="Enter other option"
                value={this.state.otherOption}
                onChange={this.handleOtherChange}
              /><br /><br /></div>
            )}
            <label htmlFor="email">Email</label><br />
            <input placeholder="Enter Your Email " type="email" id="email" name="email" value={this.state.email} onChange={this.handleChange} required /><br /><br />
            <label htmlFor="password">Password</label><br />
            <div style={{ position: "relative" }}>
              <input placeholder="Enter Your Password" type={this.state.showPassword ? "text" : "password"} id="password" name="password" value={this.state.password} onChange={this.handleChange} required />
              <span onClick={() => this.toggleVisibility("showPassword")} style={{ position: "absolute", right: "10px", bottom: "10px", cursor: "pointer" }}>
                {this.state.showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div> <br />

            <label htmlFor="confirmPassword">Comfirm Password</label><br />
            <div style={{ position: "relative" }}>
              <input placeholder="Enter Your Comfirm Password" type={this.state.showConfirmPassword ? "text" : "password"} id="confirmPassword" name="confirmPassword" value={this.state.confirmPassword} onChange={this.handleChange} required />
              <span onClick={() => this.toggleVisibility("showConfirmPassword")} style={{ position: "absolute", right: "10px", bottom: "10px", cursor: "pointer" }}>
                {this.state.showConfirmPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div><br />
            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Signing up..." : "Submit"}
            </button> <br />
            {this.state.error && <p className="account_error">{this.state.error}</p>}<br />
            {/* <button className="signup_google" onClick={() => {this.login()}}><FaGooglePlusG /> <span>Continue With Google</span></button> */}
            <GoogleSignup />
            {/* <GoogleLogin
              onSuccess={credentialResponse => {
                const userID = jwtDecode(credentialResponse.credential)
                console.log(userID);
              }}
              onError={() => {
                console.log('Login Failed');
              }}
            /> */}
            <br />
            <p>Already on Geo-Academy? <Link to="/login"><span>Login</span></Link></p>
          </form>
        </div>
        <SignupFooter />
      </div>
    )
  }
}

export default Signup